import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveEvvEmployeeData {
  id?: string;
  employee_custom_id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  ssn: string;
  email: string;
  phone: string;
  position: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  zip: string;
  hiring_date: any;
  termination_date: any;
  shift_start_time: any;
  shift_end_time: any;
}

const saveEvvEmployee = ({ id, ...postData }: ISaveEvvEmployeeData) => {
  if (id) {
    const newEndpoints = endpoints.evv.evvEmployeeById.replace('{employeeId}', id);
    return http().put(newEndpoints, postData);
  } else {
    return http().post(endpoints.evv.employee, postData);
  }
};

export function useSaveEvvEmployee() {
  return useMutation({ mutationFn: saveEvvEmployee });
}
